import { Alert } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';

export const FooterStyled = styled.footer<{ $withValidationErrors: boolean }>`
  padding: 8rem 0 10rem;
  ${({ $withValidationErrors }): CSSProp =>
    $withValidationErrors &&
    css`
      padding-top: 4rem;
    `}
`;

export const AlertStyled = styled(Alert)`
  margin-bottom: 8rem;
  min-height: 12rem;
`;

export const ButtonsWrapperStyled = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.6rem;
`;
